import { useEffect, useState } from "react";
import { ILogin } from "../../models/Login";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { Fetch } from "../../shared/Fetch";
import { Divider } from "primereact/divider";
import ConsultantProfile from "./ConsultantProfle";
import { ConsultantProjectDetails } from "./ConsultantProjectDetails";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./ConsultantDashboard.css";
import { Button } from "primereact/button";
import TimesheetSection from "./TimesheetSection";
import Payment from "./Payment";
import { Document } from "./Document";
import { AddConsultantTimeSheet } from "./AddConsultantTimeSheet";
import { ITimesheet } from "../../models/Timesheet";
import { MyProjects } from "./MyProjects";

export const Dashboard = () => {
  const [newTM, setNewTM] = useState<boolean>(false);
  const [leftTimesheetDates, setLeftTimesheetDates] = useState<string[]>([]);
  const [timesheet, setTimesheet] = useState<ITimesheet[]>([]);
  const [data, setData] = useState<any>([]);
  const [disp, setDisp] = useState<boolean>(false);
  const [modal4, setModal4] = useState({ singleData: {}, open: false } as {
    singleData: any;
    open: boolean;
  });
  const [modal3, setModal3] = useState({ singleData: {}, open: false } as {
    singleData: any;
    open: boolean;
  });
  const [modal2, setModal2] = useState({ singleData: {}, open: false } as {
    singleData: any;
    open: boolean;
  });
  const [modal1, setModal1] = useState({ singleData: {}, open: false } as {
    singleData: any;
    open: boolean;
  });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

  const GetTimesheetLeftDates = async () => {
    let extraQuery = "";

    const response = await Fetch(
      "ResourceTimesheet/getLeftTimeSheetDates",
      "GET",
      null,
      `PO_ID=${loginObj.pOs[0]?.pO_ID}&dataType=1` + extraQuery,
      null
    );
    if (response) {
      const data = await response.json();
      if (data.length > 0) {
        setDisp((prev) => (prev = true));
        console.log(data);
        setLeftTimesheetDates(data);
      }
    }
  };
  const GetTimesheets = async () => {
    let extraQuery = "";

    const response = await Fetch(
      "ResourceTimesheet",
      "GET",
      null,
      `byConsultant=0&byPO_ID=${loginObj.pOs[0]?.pO_ID}` + extraQuery,
      null
    );
    if (response) {
      const data = await response.json();
      setTimesheet(data);
      if (data.length === 0) {
        setNewTM(true);
      }
    }
  };

  useEffect(() => {
    if (loginObj.pOs[0]?.pO_ID) {
      GetTimesheetLeftDates();
      GetTimesheets();
    }
  }, []);

  const onSaveForm = () => {
    if (loginObj.pOs[0]?.pO_ID) {
      setDisp((prev) => (prev = false));
      GetTimesheetLeftDates();
      GetTimesheets();
    }
  };

  const hideDialog2 = () => {
    setModal2({ singleData: {}, open: false });
    setModal1({ singleData: {}, open: false });
    setModal3({ singleData: {}, open: false });
    setModal4({ singleData: {}, open: false });
  };
  const handleShowPO = (rowData: any) => {
    setModal4({ open: true, singleData: rowData });
  };
  const handleTimeSheet = (rowData: any) => {
    setModal3({ open: true, singleData: rowData });
  };
  const handlePayment = (rowData: any) => {
    setModal2({ open: true, singleData: rowData });
  };
  const handleDocument = (rowData: any) => {
    setModal1({ open: true, singleData: rowData });
  };
  // function handleTimeSheet() {}
  const projectData = {
    endClient: "Big Client Inc.",
    location: "San Francisco, CA",
    role: "Frontend Developer",
    startDate: "2024-01-01",
    duration: 12,
    expectedEndDate: "2025-01-01",
    jobDescription: "Developing UI components for the web application",
  };

  return (
    <>
      <Card title="Consultant Dashboard" className="consultant-dashboard-card">
        <div className="consultant-dashboard">
          <div className="consultant-column">
            <ConsultantProfile profile={loginObj.pOs[0]} />
          </div>

          <div className="consultant-column">
            <ConsultantProjectDetails project={loginObj.pOs[0]} />
          </div>
        </div>
      </Card>
      <div className="button-container">
        <Button label="Show My Projects" onClick={handleShowPO} />
        <Button label="Show My Timesheets" onClick={handleTimeSheet} />
        <Button label="Show My Payments" onClick={handlePayment} />
        <Button label="Show My Documents" onClick={handleDocument} />
      </div>
      {/* <TimesheetSection /> */}
      {/* <PaymentSection /> */}
      <Card>
        {disp && (
          <AddConsultantTimeSheet
            po={loginObj.pOs[0]}
            leftTimesheetDates={leftTimesheetDates}
            onSave={onSaveForm}
          />
        )}
      </Card>

      <TimesheetSection
        singleData={modal3.singleData}
        open={modal3.open}
        hideDialog={hideDialog2}
      />
      <Payment
        singleData={modal2.singleData}
        open={modal2.open}
        hideDialog={hideDialog2}
      />
      <Document
        singleData={modal1.singleData}
        po={loginObj.pOs[0]}
        open={modal1.open}
        hideDialog={hideDialog2}
      />
      <MyProjects
        singleData={modal4.singleData}
        po={loginObj.pOs[0]}
        open={modal4.open}
        hideDialog={hideDialog2}
      />
    </>
  );
};
